<header *ngIf="isLoggedIn && user" class="w-full">

  <div class="bg-secondary-900 relative z-10 flex h-16 flex-shrink-0 shadow-sm">
    <div class="mx-auto lg:mx-0 lg:max-w-none flex items-center justify-between w-full px-4 sm:px-6">

      <div class="flex justify-center items-center">

        <!-- Logo -->
        <div class="flex items-center pr-6 lg:pr-6">
          <a [routerLink]="['/dashboard']">
            <img class="h-8 w-auto" src="/assets/alternative_whihte_horizontal.png" alt="Sales OMMO" height="96" width="96">
          </a>
        </div>

        <!-- Back -->
        <div *ngIf="location === 'reports'" class="flex items-center pr-6 lg:pr-6">
          <a routerLink="/dashboard">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6 text-white">
              <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
          </a>
        </div>

      </div>

      <div class="flex items-center">
        <app-header-right-side></app-header-right-side>
      </div>

    </div>
  </div>

</header>
